import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './components/reports/reports.component';
import { IdmsHeadersModule } from '../headers/idms-headers.module';
import { ReportsContentComponent } from './components/reports-content/reports-content.component';
import { DxChartModule, DxDataGridModule, DxDateBoxModule, DxPieChartModule, DxProgressBarModule, DxSelectBoxModule } from 'devextreme-angular';
import { MaterialModule } from 'src/app/shared/material.module';
import { ReportsListComponent } from './components/reports-list/reports-list.component';
import { InstanceReportsComponent } from './components/instance-reports/instance-reports.component';
import { ReportsDataComponent } from './components/reports-data/reports-data.component';
import { ViewReportComponent } from './components/view-report/view-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InstanceItemReportsComponent } from 'src/app/Modules/management/components/instance/instance-item-reports/instance-item-reports.component';
import { ScheduleReportsComponent } from './components/schedule-reports/schedule-reports.component';
import { ActivityProgressReportComponent } from './components/activity-progress-report/activity-progress-report.component';
import { SharedPipeModule } from 'src/app/shared/shared-pipe.module';
import { ActivityProgressReportChartComponent } from './components/activity-progress-report-chart/activity-progress-report-chart.component';
import { TranslocoModule } from '@jsverse/transloco';
import { ReportSubscriptionComponent } from './components/report-subscription/report-subscription.component';
import { ReportSubscriptionAddComponent } from './components/report-subscription-add/report-subscription-add.component';
import { RouterOutlet } from '@angular/router';
import { ReportDesignerComponent } from './components/report-designer/report-designer.component';
import { DevexpressReportingModule } from 'devexpress-reporting-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomDashboardComponent } from './components/custom-dashboard/custom-dashboard.component';
import { CustomKpiBarComponent } from './components/custom-kpi-bar/custom-kpi-bar.component';
import { SummaryBarChartComponent } from './components/summary-bar-chart/summary-bar-chart.component';
import { SummaryTableComponent } from './components/summary-table/summary-table.component';
@NgModule({
    declarations: [
        ReportsComponent,
        ReportsContentComponent,
        ReportsListComponent,
        ReportsDataComponent,
        ViewReportComponent,
        InstanceReportsComponent,
        InstanceItemReportsComponent,
        ScheduleReportsComponent,
        ActivityProgressReportComponent,
        ActivityProgressReportChartComponent,
        ReportSubscriptionComponent,
        ReportSubscriptionAddComponent,
        ReportDesignerComponent,
        CustomDashboardComponent,
        CustomKpiBarComponent,
        SummaryBarChartComponent,
        SummaryTableComponent,
    ],
    imports: [
        CommonModule,
        IdmsHeadersModule,
        DxDataGridModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        DxPieChartModule,
        DxChartModule,
        SharedPipeModule,
        TranslocoModule,
        RouterOutlet,
        DevexpressReportingModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        SharedModule,
        DxProgressBarModule,
    ],
    exports: [InstanceReportsComponent],
})
export class ReportsModule {}
